<template>
    <div class="page-container">

        <div class="table-section">
            <el-card class="table-card" shadow="never">

                <el-form :model="from" size="small" :inline="true" class="filter-form">
                    <el-form-item label="审核状态">
                        <el-select v-model="from.status" placeholder="请选择状态" clearable>
                            <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学校名称">
                        <el-input v-model="from.school" placeholder="请输入学校名称" clearable />
                    </el-form-item>
                    <el-form-item label="地市">
                        <el-input v-model="from.address" placeholder="请输入地市" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getProjectList">查询</el-button>
                        <el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
				
				<el-row :gutter="20">
				  <el-col :span="6">
				    <el-button type="primary" @click="handlewenjian">下载文件</el-button>
				  </el-col>
				</el-row>
				
                <el-table 
                    :data="tableData" 
                    style="width: 100%" 
                    v-loading="loading"
                    element-loading-text="加载中..."
                    stripe
                    header-row-class-name="table-header"
                >
                    <el-table-column align="left" prop="name" label="项目名称">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.name" placement="top">
                                <span class="project-name">{{ scope.row.name }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="school" label="学校名称" width="400">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.school.name" placement="top">
                                <span class="school-name">{{ scope.row.school.name }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="address" label="地市" width="400" />
                    <el-table-column align="center" prop="dutyperson" label="负责人" width="160">
                        <template slot-scope="scope">
                            <div class="person-info">
                                <i class="el-icon-user-solid person-icon"></i>
                                <span>{{ scope.row.dutyperson }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="dutypersonphone" label="联系电话" width="180">
                        <template slot-scope="scope">
                            <div class="phone-info">
                                <i class="el-icon-phone phone-icon"></i>
                                <span>{{ scope.row.dutypersonphone }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="status" label="状态" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.status==1?"未审核":scope.row.status==2?'地区预审通过':scope.row.status==-2?'地区预审未通过':'' }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button 
                                size="mini" 
                                type="primary" 
                                icon="el-icon-edit-outline" 
                                @click="handleEdit(scope.row)"
                                circle
                                title="审核"
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="pagination-container">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="from.page"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="from.limit"
                        layout="sizes, prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import { getMatchAll, getAdminProjectList ,getProjectFind,yijian,updateAdminProject,imporExcel} from "@/api/signUp.js"
    export default {
        data() {
            return {
                open: false,
                loading: false,
                submitting: false,
                tableData: [],
                from: {
                    page:1,
                    limit:10,
                    admin_id: null,
                    status: 1,
                    yearamount: 2025,

                    // page: 1
                    // limit: 5
                    // admin_id: 31
                    // status: 1
                    // yearamount: 2026
                },
                model: {
                    radio: '通过',
                    liyou: '',
                },
                statusList: [{
                    value: 1,
                    label: '未审核'
                }, {
                    value: 2,
                    label: '地区预审通过'
                }, {
                    value: -2,
                    label: '地区预审未通过'
                }],
                yearList: [],
                rules:{},
                // tableData:[], // 移除重复定义
                total: 0,
                currentProject: {}, // 当前项目详情
                activeTab: 'step1', // 当前激活的标签页
                yijianList:[],//意见列表
            }
        },
        mounted() {
            this.from.admin_id = this.$route.query.admin_id;
            this.getYear()
        },
        methods: {
            resetForm(){
                this.from={
					page:1,
					limit:100,
					admin_id: this.$route.query.admin_id,
					status: 1,
					yearamount: 2025,
				}
                this.getProjectList();
            },
            getYear() {
                this.loading = true;
                getMatchAll().then(res => {
                   this.yearList = res.data.data.map(v => ({
                        value: v?.id,
                        label: v?.yearamount,
                    }));
                    this.from.yearamount = this.yearList[0].label;
                    this.getProjectList();
                })
            },
            getProjectList(){
                this.loading = true;
                getAdminProjectList(this.from).then(res => {
                    const dataList = res.data?.data || [];
                    this.tableData = dataList;
                    
                    // 当后端无法提供准确的总条数(count)时，采用动态计算虚拟total的方式实现上下页切换
                    if (res.data?.count) {
                        this.total = res.data.count;
                    } else if (dataList.length === this.from.limit) {
                        // 如果当前页满载，说明可能还有下一页，虚拟一个比当前数据量多1的total，使得下一页按钮可用
                        this.total = this.from.page * this.from.limit + 1;
                    } else {
                        // 如果当前页未满载，说明这是最后一页，计算实际到达的数据总量
                        this.total = (this.from.page - 1) * this.from.limit + dataList.length;
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },
            handleSizeChange(val) {
                this.from.limit = val;
                this.from.page = 1;
                this.getProjectList();
            },
            handleCurrentChange(val) {
                this.from.page = val;
                this.getProjectList();
            },
            handleEdit(row) {
                this.open = true;
                this.$router.push({
                    name: "project",
                    query: {
                        project_id: row.id,
                        type:1
                    }
                });
            },
			//下载文件
			handlewenjian(){
				imporExcel(this.from).then(res=>{
					let weye = process.env.VUE_APP_URL + res.data.data
					// console.log(weye)
                    window.open(weye, '_blank')
				})
			},
            submitForm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        // 模拟提交
                        updateAdminProject({
                            project_id: this.currentProject.id,//项目id
                            admin_id: this.from.admin_id,//管理员id
                            operation: this.model.radio,//审核状态
                            reason: this.model.liyou//拒绝理由
                        }).then(res => {
                            if( this.model.radio == '通过'){
                                this.submitting = false;
                                this.open = false;
                                this.$message.success('通过完成');
                                this.getProjectList();
                            }else{
                                this.submitting = false;
                                this.open = false;
                                this.$message.error('拒绝成功');
                            }
                        })
                    }
                });
            },
            getStatusType(status) {
                const statusMap = {
                    '1': 'warning',
                    '2': 'success',
                    '-2': 'danger'
                };
                return statusMap[status] || 'info';
            },
            getStatusText(status) {
                const statusItem = this.statusList.find(item => item.value === status);
                return statusItem ? statusItem.label : '未知状态';
            }
        }
    }
</script>

<style>
body {
	margin: 0;
}
</style>

<style scoped lang="scss">
    .pagination-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
table {

		// border: #333 1px solid;
		tr {
			border: #333 1px solid;
		}

		td {
			border: #333 1px solid;
		}
	}
.page-container {
	min-height: 100vh;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	padding: 24px;
}

.page-header {
	text-align: center;
	margin-bottom: 32px;
	padding: 40px 0;
	background: white;
	border-radius: 16px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.page-title {
	font-size: 36px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0 0 12px 0;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}

.page-subtitle {
	font-size: 16px;
	color: #7f8c8d;
	margin: 0;
}

.filter-section {
	/* margin-bottom: 24px; */
}

.filter-card {
	border: none;
	border-radius: 12px 12px 0 0;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.filter-form {
	margin: 0;
}

.table-section {
	margin-bottom: 24px;
}

.table-card {
	border: none;
	border-radius:12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	overflow: hidden;
}

.table-header {
	background: #f8f9fa;
}

.project-name, .school-name {
	/* display: inline-block; */
	/* max-width: 200px; */
	/* white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis; */
}

.person-info, .phone-info {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
}

.person-icon, .phone-icon {
	color: #409eff;
	font-size: 14px;
}

.review-dialog {
	border-radius: 12px;
}

.dialog-content {
	padding: 20px 0;
}

.radio-group {
	display: flex;
	gap: 24px;
}

.radio-option {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 16px 24px;
	border: 2px solid #e4e7ed;
	border-radius: 8px;
	transition: all 0.3s ease;
	cursor: pointer;
}

.radio-option:hover {
	border-color: #409eff;
	background-color: #f0f9ff;
}

.radio-option.is-checked {
	border-color: #409eff;
	background-color: #f0f9ff;
}

.success-icon {
	color: #67c23a;
	font-size: 18px;
}

.error-icon {
	color: #f56c6c;
	font-size: 18px;
}

.dialog-footer {
	text-align: right;
	padding-top: 20px;
	border-top: 1px solid #e4e7ed;
}

/* Element UI 样式覆盖 */
::v-deep .el-card__body {
	padding: 24px;
}

::v-deep .el-table {
	border-radius: 8px;
}

::v-deep .el-table th {
	background-color: #f8f9fa;
	color: #2c3e50;
	font-weight: 600;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
	background-color: #fafbfc;
}

::v-deep .el-tag {
	border-radius: 20px;
	padding: 4px 12px;
	font-weight: 500;
}

::v-deep .el-button--mini.is-circle {
	width: 32px;
	height: 32px;
	padding: 0;
}

::v-deep .el-dialog__header {
	padding: 24px 24px 20px;
	border-bottom: 1px solid #e4e7ed;
}

::v-deep .el-dialog__title {
	font-size: 18px;
	font-weight: 600;
	color: #2c3e50;
}

::v-deep .el-dialog__body {
	padding: 0 24px;
}

::v-deep .el-dialog__footer {
	padding: 20px 24px 24px;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
	background-color: #409eff;
	border-color: #409eff;
}

::v-deep .el-radio__input.is-checked + .el-radio__label {
	color: #409eff;
}
</style>